export default class ReferentielTypesService {
    static $inject = ['$http'];

    constructor($http) {
        this.$http = $http;
    }

    async getAll(domaine) {
        const url = `${__configuration.apiUrl}/massia/domaines/${domaine}/types`;
        const res = await this.$http.get(url);
        return res.data;
    }

    async getAllMesures(domaine, idFamille) {
        if (idFamille) {
            const url = `${__configuration.apiUrl}/massia/domaines/${domaine}/types/filtre-famille/${idFamille}`;
            const res = await this.$http.get(url);
            return res.data;
        }

        return null;
    }

    async getCaracteristiques(id) {
        const url = `${__configuration.apiUrl}/massia/types/${id}/format-caracteristiques`;
        const res = await this.$http.get(url);
        return res.data;
    }

    async GetNiveauVisibilite(id) {
        const url = `${__configuration.apiUrl}/massia/types/${id}/niveau-visibilite`;
        const res = await this.$http.get(url);
        return res.data;
    }

    async getElementsFromCaracteristique(idCarac) {
        const url = `${__configuration.apiUrl}/massia/caracteristiques/elements/${idCarac}`;
        const res = await this.$http.get(url);

        return res.data;
    }
}
